import {Component, OnInit, ViewChild, EventEmitter, Output} from '@angular/core';
import {Router} from '@angular/router';
import {ITableHeader, TableComponent} from '../../shared/table/TableComponent';
import {PagedListOfUser, User} from '../../../services/api.client';
import {Agency} from '../../../services/api.client';

import {UserService} from '../../../services/UserService';
import {NotificationService} from '../../../services/NotificationService';
import {extractEnumNames, splitCamelCase} from '../../../utilities/Util';
import {DropdownValue} from '../../../utilities/DropdownComponent';
import {SystemData} from '../../../services/api.client';
import {UserStatusType} from '../../../services/api.client';
import {UserType} from '../../../services/api.client';
import {AgencyListModalComponent} from '../agency/AgencyListModalComponent';
import {SystemService} from '../../../services/SystemService';

@Component({
    templateUrl: './UserListComponent.html',
    styleUrls: ['./UserListComponent.scss'],
    standalone: false
})

export class UserListComponent implements OnInit {

  constructor(private _userService: UserService,
              private system: SystemService,
              private _notificationService: NotificationService,
              private _router: Router) {
  }
  isLoading: boolean;
  systemData: SystemData;
  selectedUserType: any;
  searchString: string = '';
  agencySearchValue = '';
  userTypes = extractEnumNames(UserType);
  userTypeDisplay = UserType;
  agencyId: string = null;

  // page-local search results (003-retire-ngrx follow-up: results must not
  // outlive the search criteria fields on this component)
  users: User[];
  pagedUsers: PagedListOfUser;

  // sorting
  currentSortName = 'LastName';
  currentSorting = false;

  tableHeaders: ITableHeader[] = [
    {text: 'Last Name', sortKey: 'LastName', ascending: true},
    {text: 'First Name', sortKey: 'FirstName'},
    {text: 'Email', sortKey: 'EmailAddress'},
    {text: 'User Type', sortKey: 'UserType', class: 'hidden-sm-down'},
    {text: 'Agency Name', class: 'hidden-sm-down', sortKey: 'Agency|AgencyName'},
    {text: 'Company Name', class: 'hidden-sm-down', sortKey: 'Company|Name'},
    {text: 'Status', class: 'hidden-sm-down', sortKey: 'Status'}
  ];

  // pagination
  limit = 10;
  currentPage = 1;
  maxSize = 1;
  totalCount: number;
  includeDisabled = false;

  // Dropdowns
  userTypeDropdown: DropdownValue[];

  @ViewChild(TableComponent)
  table: TableComponent;

  // //MODAL
  @ViewChild(AgencyListModalComponent)
  agencyListModal: AgencyListModalComponent;
  @Output('onShowAgencyModal') _showAgencies = new EventEmitter();
  private agencyList: AgencyListModalComponent;

  // selected agency
  agency: Agency;
  selectedAgencyName = '   select agency';

  ngOnInit(): void {
    this.loadUserTypes();
  }

  // Current Selected User
  setCurrentSelectedUser(user: User): void {
    this._userService.setCurrentSelectedUser(user);
  }

  sortUsers(options: ITableHeader): void {
    this.currentSortName = options.sortKey;
    this.currentSorting = !options.ascending;
    this.searchUsers();
  }

  setLimit(limit: number): void {// # of rows per page
    this.limit = limit;
    this.searchUsers();
  }

  setPage(page: number): void {
    setTimeout(() => {
      this.currentPage = page; // set current page
      this.searchUsers();

    });
  }

  // set selected Pledge Type ID
  selectUserType(userType): void {
    this.selectedUserType = userType;
    this.searchUsers();
  }

  // dropdown - agencies
  loadUserTypes(): void {// get Pledge Types
    if (this.userTypes) {
      this.userTypeDropdown = [];
      for (const userType of this.userTypes) {
        this.userTypeDropdown.push(new DropdownValue(userType.value.toString(), splitCamelCase(userType.key)));
      }
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.searchUsers();

    });
  }

  // get Users
  searchUsers(): void {
    const request = this._userService.searchUsers(
      this.searchString,
      this.agencyId,
      this.selectedUserType,
      this.includeDisabled,
      this.currentSortName,
      this.currentSorting,
      this.limit,
      (this.currentPage - 1) * this.limit
    );
    this.table.request = request;
    request.subscribe({
      next: (paged) => {
        this.pagedUsers = paged;
        this.users = paged?.items;
        this.totalCount = paged?.totalCount;
      }, error: () => {}
    });
  }

  // download Users list
  downloadUsers(): string {
    const data = {
      searchValue: this.searchString,
      agencyId: this.agencyId,
      userTypeId: this.selectedUserType,
      includeDisabled: this.includeDisabled,
      sortName: this.currentSortName,
      limit: this.limit,
      offset: (this.currentPage - 1) * this.limit
    };

    return this._userService.downloadUserList(data);
  }

  isSystemAdmin(): boolean {
    return this.system.isSystemAdmin;
  }

  // Whether the current user may edit this row. Rows that can't be edited are rendered
  // as plain text (see the template) so clicking them never triggers a navigation and
  // the getUserById API call that the CanEditUserGuard would otherwise make.
  canEdit(user: User): boolean {
    return this.system.canEditUser(user);
  }

  // search value
  setSearchValue(searchValue): void {
    this.searchString = searchValue;
  }

  clearSearch(): void {
    this.searchString = '';
    this.searchUsers();
  }

  formatUserType(type): string {
    return splitCamelCase(type);
  }

  // show Agency Modal
  showAgencyModal(): boolean {
    this.agencyListModal.open();
    return false;
  }

  onAgencySelected(selectedAgency): void {
    if (selectedAgency) {
      selectedAgency.agencyName ? this.selectedAgencyName = selectedAgency.agencyName : this.selectedAgencyName = '';
      this.agencySearchValue = selectedAgency.agencyName;
      this.agencyId = selectedAgency.id;
      this.searchUsers();
    } else {
      this.selectedAgencyName = '';
      this.agencySearchValue = '';
      this.agencyId = null;
      this.searchUsers();
    }
  }
}
